const KEY = 'bs.activeProfileId';

export function getActiveProfileId(): string | null {
  return localStorage.getItem(KEY);
}

export function setActiveProfileId(profileId: string | null): void {
  if (profileId) {
    localStorage.setItem(KEY, profileId);
  } else {
    localStorage.removeItem(KEY);
  }
  window.dispatchEvent(new Event('bs:activeProfileChanged'));
}

export function onActiveProfileChange(handler: () => void): () => void {
  window.addEventListener('bs:activeProfileChanged', handler);
  return () => window.removeEventListener('bs:activeProfileChanged', handler);
}

// Welk profiel hoort bij dit signaal. Een deeplink uit de signaalmail draagt de
// klant mee als ?client=, want een gebruiker kan aan meerdere profielen hangen
// en anders wordt het signaal opgezocht onder het profiel dat toevallig actief
// staat. Dat gaf "signaal niet gevonden" terwijl de gebruiker er recht op had.
//
// De klant uit de link telt alleen als de gebruiker hem ook echt heeft. Een
// onbekende waarde negeren we; de API zou hem toch weigeren, en het profiel
// omzetten naar iets wat niet bestaat maakt de rest van de interface stuk.
export function resolveSignalClient(options: {
  clientFromRoute?: string;
  clientFromLink: string | null;
  activeProfileId: string | null;
  profileIds: string[];
}): { profileId: string | null; switchTo: string | null } {
  const { clientFromRoute, clientFromLink, activeProfileId, profileIds } = options;

  if (clientFromRoute) {
    return { profileId: clientFromRoute, switchTo: null };
  }

  const linked = clientFromLink && profileIds.includes(clientFromLink) ? clientFromLink : null;
  if (!linked) {
    return { profileId: activeProfileId, switchTo: null };
  }

  return { profileId: linked, switchTo: linked === activeProfileId ? null : linked };
}
